import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgxLoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { AuthGuardLogin } from '../guards/auth-guard-login.service';
import { ValidateEmailComponent } from './validate-email/validate-email.component';
import { ActAsUserComponent } from './actAsUser/actAsUser.component';

export const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: 'login',
                component: NgxLoginComponent,
                canActivate: [AuthGuardLogin],
            },
            {
                path: 'registro',
                component: SignupComponent,
            },
          {
            path: 'yolo',
            component: ActAsUserComponent,
          },
            {
              path: 'validate-email',
              component: ValidateEmailComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class NgxAuthRoutingModule {
}
